import Checkbox from "@mui/material/Checkbox";
import FlavorTabShimmer from "./FlavorTabShimmer";
import { Chip, Grid } from "@mui/material";
import { Favorite, FavoriteBorder } from "@mui/icons-material";
import { FLAVOR_DRIVEN_TREATS } from "../utils/constants";
import RecipeActiveListItem from "./RecipeActiveListItem";

const ActiveList = ({
  store,
  flavors,
  containerOptions,
  tab,
  flavorLoading,
  tCount,
  handleSellerCheckFromChild,
  containersOptionsArray,
  showImagePDF,
  handleAdminTreatTreatCheck,
}) => {
  const isThisBlockShow = (cat) => {
    return cat.flavors.some((itm) =>
      tab === 0 ? itm.is_recent : itm.favourite
    );
  };

  let AllMainFlavors = flavors;
  // if(store?.intRitasStoreID !== TEST_INTRITASSTOREID){
  AllMainFlavors = flavors?.filter(
    (i) => i?.intProductTypeID !== FLAVOR_DRIVEN_TREATS
  );
  // }

  const flavorDrivenTreats = flavors?.find(
    (i) => i?.intProductTypeID === FLAVOR_DRIVEN_TREATS
  );

  return (
    <div key={tab?.toString()}>
      <main>
        <div className="mx-auto max-w-7xl">
          <div className="px-2 py-1 sm:px-0">
            <div className="rounded-md bg-white "></div>
            {flavorLoading ? (
              <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                <FlavorTabShimmer />
                <FlavorTabShimmer />
                <FlavorTabShimmer />
                <FlavorTabShimmer />
                <FlavorTabShimmer />
              </div>
            ) : (
              <div>
                <Grid
                  container
                  justify="flex-end"
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                  className="sticky bg-[#e5e5e5]"
                >
                  <Chip
                    size="small"
                    className="m-2"
                    label="QC: Quarter Container"
                  />
                  <Chip
                    size="small"
                    className="m-2"
                    label="HC: Half Container"
                  />
                  <Chip
                    size="small"
                    className="m-2"
                    label="SC: Single Container"
                  />
                  <Chip
                    size="small"
                    className="m-2"
                    label="DC: Double Container"
                  />
                  <Chip
                    size="small"
                    className="m-2"
                    label={
                      <span className="flex">
                        <span >
                          <img
                            // className="rounded-full"
                            style={{ width: "20px" }}
                            src={"../assets/icons/recipe-card-icon.png"}
                            alt="recipe"
                          />
                        </span>
                        <span className="pl-1">: Recipe Card</span>
                      </span>
                    }
                  />
                </Grid>
                {store ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-5">
                    {AllMainFlavors?.map((category, categoryIndex) => (
                      <RecipeActiveListItem
                        isThisBlockShow={isThisBlockShow}
                        category={category}
                        tCount={tCount}
                        tab={tab}
                        handleSellerCheckFromChild={handleSellerCheckFromChild}
                        categoryIndex={categoryIndex}
                        containersOptionsArray={containersOptionsArray}
                        showImagePDF={showImagePDF}
                        containerOptions={containerOptions}
                      />
                    ))}
                    {flavorDrivenTreats &&
                      flavorDrivenTreats?.categories?.map(
                        (category, categoryIndex) => (
                          <div
                            className="bg-white rounded-md"
                            style={{
                              display: isThisBlockShow(category) ? "" : "none",
                            }}
                          >
                            <div className="card-header-border">
                              <div className="grid grid-cols-2 divide-x-0 my-5 ">
                                <div
                                  sx={{ width: 8 - `${tCount}` }}
                                  className="pl-2 text-card-header"
                                >
                                  <h6 className="text-card-header">
                                    {`${category.base_product_type_name} (${
                                      category?.flavors.filter((itm) =>
                                        tab === 0
                                          ? itm.is_recent
                                          : itm.favourite
                                      )?.length
                                    })`}
                                  </h6>
                                </div>
                                <div sx={{ width: `${tCount}` }}></div>
                              </div>
                            </div>
                            <div className="flow-root">
                              <ul className="divide-gray-200 dark:divide-gray-700">
                                {category?.flavors
                                  .filter((itm) =>
                                    tab === 0 ? itm.is_recent : itm.favourite
                                  )
                                  .map((flv, flavorIndex) => {
                                    return (
                                      <li key={flavorIndex.toString()}>
                                        <div className="grid grid-cols-2 divide-x-0 card-item-style  pl-2">
                                          <div
                                            sx={{
                                              width: 8 - `${tCount}`,
                                            }}
                                            className="w-full pt-3"
                                            style={{ display: "flex" }}
                                          >
                                            <span
                                              className="flex-shrink-0 w-7"
                                              style={{
                                                verticalAlign: "bottom",
                                              }}
                                            >
                                              <img
                                                className="rounded-full"
                                                src={flv.thumbnailURL}
                                                onError={(event) => {
                                                  event.target.src =
                                                    "./assets/icons/circle.png";
                                                  event.onerror = null;
                                                }}
                                                alt="flvimage"
                                              />
                                              <Checkbox
                                                onChange={(e) =>
                                                  handleAdminTreatTreatCheck(
                                                    e,
                                                    flavors?.length - 1,
                                                    categoryIndex,
                                                    flv?.intFlavorID,
                                                    "favourite",
                                                    flv?.fid
                                                  )
                                                }
                                                checked={flv?.favourite}
                                                style={{
                                                  position: "absolute",
                                                  marginTop: "-40px",
                                                  marginLeft: "10px",
                                                }}
                                                size="small"
                                                icon={
                                                  <FavoriteBorder className="text-gray-300" />
                                                }
                                                checkedIcon={
                                                  <Favorite color="error" />
                                                }
                                              />
                                            </span>
                                            <span
                                              style={{
                                                fontSize: "12.5px",
                                                paddingLeft: "12px",
                                                paddingTop: "6px",
                                              }}
                                            >
                                              {flv?.flavor_name}
                                            </span>
                                          </div>
                                          <div
                                            sx={{
                                              width: `${tCount}`,
                                            }}
                                          >
                                            <div
                                              className={`grid text-center`}
                                              style={{
                                                marginTop: "16px",
                                                gridTemplateColumns: `repeat(${containersOptionsArray?.length},1fr)`,
                                              }}
                                            >
                                              {containerOptions.QC && (
                                                <div
                                                  onClick={(e) =>
                                                    showImagePDF(
                                                      flv?.quarterContainer
                                                    )
                                                  }
                                                  style={{
                                                    color:
                                                      flv?.quarterContainer &&
                                                      flv?.quarterContainer !==
                                                        "NA"
                                                        ? "#0000EE"
                                                        : "darkgrey",
                                                    cursor:
                                                      flv?.quarterContainer &&
                                                      flv?.quarterContainer !==
                                                        "NA"
                                                        ? "pointer"
                                                        : "not-allowed",
                                                  }}
                                                >
                                                  QC
                                                </div>
                                              )}
                                              {containerOptions.HC && (
                                                <div
                                                  onClick={(e) =>
                                                    showImagePDF(
                                                      flv?.halfContainer
                                                    )
                                                  }
                                                  style={{
                                                    color:
                                                      flv?.halfContainer &&
                                                      flv?.halfContainer !==
                                                        "NA"
                                                        ? "#0000EE"
                                                        : "darkgrey",
                                                    cursor:
                                                      flv?.halfContainer &&
                                                      flv?.halfContainer !==
                                                        "NA"
                                                        ? "pointer"
                                                        : "not-allowed",
                                                  }}
                                                >
                                                  HC
                                                </div>
                                              )}
                                              {containerOptions.SC && (
                                                <div
                                                  onClick={(e) =>
                                                    showImagePDF(
                                                      flv?.singleContainer
                                                    )
                                                  }
                                                  style={{
                                                    color:
                                                      flv?.singleContainer &&
                                                      flv?.singleContainer !==
                                                        "NA"
                                                        ? "#0000EE"
                                                        : "darkgrey",
                                                    cursor:
                                                      flv?.singleContainer &&
                                                      flv?.singleContainer !==
                                                        "NA"
                                                        ? "pointer"
                                                        : "not-allowed",
                                                  }}
                                                >
                                                  SC
                                                </div>
                                              )}
                                              {containerOptions.DC && (
                                                <div
                                                  onClick={(e) =>
                                                    showImagePDF(
                                                      flv?.doubleContainer
                                                    )
                                                  }
                                                  style={{
                                                    color:
                                                      flv?.doubleContainer &&
                                                      flv?.doubleContainer !==
                                                        "NA"
                                                        ? "#0000EE"
                                                        : "darkgrey",
                                                    cursor:
                                                      flv?.doubleContainer &&
                                                      flv?.doubleContainer !==
                                                        "NA"
                                                        ? "pointer"
                                                        : "not-allowed",
                                                  }}
                                                >
                                                  DC
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                    );
                                  })}
                              </ul>
                            </div>
                          </div>
                        )
                      )}
                  </div>
                ) : (
                  <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                    Please select a store
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default ActiveList;
